import store from '@/state/store';

export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/account/login.vue'),
    meta: {
      title: 'Login',
      layout: 'Blank'
    }
  },
  {
    path: '/',
    name: 'dashboard-page',
    redirect: (to) => {
      if (store.getters['auth/loggedIn']) {
        return '/';
      } else {
        return '/login';
      }
    },
    meta: {
      title: 'Dashboard'
    },
    component: () => import('../views/dashboard/index.vue')
  },

  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('../views/account/forgot-password.vue'),
    meta: {
      layout: 'Blank',
      title: 'Forgot Password',
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({
            name: 'default'
          });
        } else {
          // Continue to the login page
          next();
        }
      }
    }
  },
  {
    path: '/role-permission',
    name: 'permissions',
    meta: {
      title: 'Roles & Permissions',
      authRequired: true,
      requiresPermission: 'role-list'
    },
    component: () => import('../views/permissions')
  },
  {
    path: '/clients',
    name: 'clients',
    meta: {
      title: 'Clients',
      authRequired: true,
      requiresPermission: 'client-list'
    },
    component: () => import('../views/clients')
  },
  {
    path: '/departments',
    name: 'departments',
    meta: {
      title: 'departments',
      authRequired: true,
      requiresPermission: 'department-list'
    },
    component: () => import('../views/departments')
  },
  {
    path: '/departments/:id/view',
    name: 'departments-view',
    meta: {
      title: 'Department View ',
      authRequired: true,
      requiresPermission: 'department-view'
    },
    props: true,
    component: () => import('../views/departments/view')
  },
  {
    path: '/positions',
    name: 'positions',
    meta: {
      title: 'Positions',
      authRequired: true,
      requiresPermission: 'position-list'
    },
    component: () => import('../views/positions')
  },
  {
    path: '/employees',
    name: 'employees',
    meta: {
      title: 'Employees',
      authRequired: true,
      requiresPermission: 'user-list'
    },
    component: () => import('../views/users')
  },
  {
    // Specific URL for the Add User form — must be before the parameterized /:mode route
    path: '/employees/adduser',
    name: 'employee-add',
    meta: {
      title: 'Add Employee',
      authRequired: true,
      requiresPermission: 'user-create'
    },
    component: () => import('../views/users/user-view-upsert.vue')
  },
  {
    path: '/employees/:mode/:id?',
    name: 'employee-view-upsert',
    meta: {
      title: 'Employee',
      authRequired: true
    },
    component: () => import('../views/users/user-view-upsert.vue')
  },
  {
    // Bare URL for the Terminate form (Add mode) — must be before the parameterised /:mode route
    path: '/employees/terminate',
    name: 'employee-terminate-add',
    meta: {
      title: 'Terminate Employee',
      authRequired: true,
      requiresPermission: 'employee-history-create'
    },
    component: () => import('../views/users/user-history-terminate-upsert.vue')
  },
  {
    path: '/employees/terminate/:mode/:id?',
    name: 'employee-terminate-upsert',
    meta: {
      title: 'Terminate Employee',
      authRequired: true
    },
    component: () => import('../views/users/user-history-terminate-upsert.vue')
  },
  {
    path: '/timeline',
    name: 'timeline',
    meta: {
      title: 'Timeline',
      authRequired: true
    },
    component: () => import('../views/timeline/timeline.vue')
  },
  {
    // Specific URL for the Add Position form — must be before the parameterized /:mode route
    path: '/employees/addposition',
    name: 'employee-promotion-add',
    meta: {
      title: 'Add Position',
      authRequired: true,
      requiresPermission: 'employee-history-create'
    },
    component: () => import('../views/users/user-history-promotion-upsert.vue')
  },
  {
    path: '/employees/promotion/:mode/:id?',
    name: 'employee-promotion-upsert',
    meta: {
      title: 'Promotion Employee',
      authRequired: true
    },
    component: () => import('../views/users/user-history-promotion-upsert.vue')
  },
  {
    path: '/profile/:tab?',
    name: 'profile',
    meta: {
      title: 'Profile',
      authRequired: true
    },
    component: () => import('../views/users/profile/profile.vue'),
    props: true
  },
  {
    path: '/profile/notifications/settings',
    name: 'notifications-settings',
    meta: {
      title: 'Notifications Settings',
      authRequired: true
    },
    component: () => import('../views/notifications/setting/index.vue')
  },
  {
    path: '/profile/notifications',
    name: 'notifications',
    meta: {
      title: 'Notifications',
      authRequired: true
    },
    component: () => import('../views/notifications/index.vue')
  },
  {
    path: '/employee/:id/view',
    name: 'users.view',
    meta: {
      title: 'View Profile',
      authRequired: true,
      requiresPermission: 'user-view'
    },
    props: true,
    component: () => import('../views/users/profile/view.vue')
  },
  // {
  //   path: '/profile/edit',
  //   name: 'profile-setting',
  //   meta: {
  //     title: 'Setting',
  //     authRequired: true
  //   },
  //   component: () => import('../views/users/profile/setting.vue')
  // },
  {
    path: '/projects',
    name: 'projects',
    meta: {
      title: 'Projects',
      authRequired: true
    },
    component: () => import('../views/projects/project-list.vue')
  },
  {
    path: '/projects/create',
    name: 'projects-create',
    meta: {
      title: 'Create Project',
      authRequired: true,
      requiresPermission: 'project-create'
    },
    component: () => import('../views/projects/create')
  },
  {
    path: '/projects/:id/edit',
    name: 'projects-edit',
    meta: {
      title: 'Update Project',
      requiresPermission: 'project-edit'
    },
    props: true,
    component: () => import('../views/projects/edit')
  },
  {
    path: '/projects/:id/view',
    name: 'projects-view',
    meta: {
      title: 'View Project',
      authRequired: true,
      requiresPermission: 'project-view'
    },
    props: true,
    component: () => import('../views/projects/view')
  },
  {
    path: '/projects/:id/tasks',
    name: 'project-tasks',
    meta: {
      title: 'View Project Tasks',
      authRequired: true
    },
    props: true,
    component: () => import('../views/tasks/index.vue')
  },
  {
    path: '/projects/:id/tasks-list',
    name: 'project-tasks-list',
    meta: {
      title: 'View Project Tasks',
      authRequired: true
    },
    props: true,
    component: () => import('../views/tasks/task-list-view.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      title: 'Dashboard',
      authRequired: true
    },
    component: () => import('../views/dashboard/index.vue')
  },

  {
    path: '/logout',
    name: 'logout',
    meta: {
      title: 'Logout',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      }
    },
    component: () => import('../views/account/login.vue')
  },

  {
    path: '/project/tasks-details/:id',
    name: 'tasks-details',
    meta: {
      title: 'Tasks Details',
      authRequired: true
    },
    component: () => import('../views/tasks/task-view-details.vue')
  },
  {
    path: '/project/tasks-details-new/:id',
    name: 'tasks-details-new',
    meta: {
      title: 'Tasks Details',
      authRequired: true
    },
    component: () => import('../views/tasks/task-view-detailsNew.vue')
  },

  {
    path: '/invoices/list',
    name: 'invoice-list',
    meta: {
      title: 'Invoice List',
      authRequired: true
    },
    component: () => import('../views/invoices/list')
  },
  {
    path: '/invoices/archive',
    name: 'invoice-archive',
    meta: {
      title: 'Archive List',
      authRequired: true
    },
    component: () => import('../views/invoices/listArchived.vue')
  },
  {
    path: '/invoices/settings',
    name: 'invoice-settings',
    meta: {
      title: 'Invoice Settings',
      authRequired: true
    },
    component: () => import('../views/invoices/settings.vue')
  },
  {
    path: '/invoices/:mode/:id?',
    name: 'payment-view-upsert',
    meta: {
      title: 'Create Invoice',
      authRequired: true
    },
    component: () => import('../views/invoices/payment-view-upsert')
  },
  {
    path: '/asset-request/list',
    redirect: '/asset-requests'
  },
  {
    path: '/asset-requests/list',
    redirect: '/asset-requests'
  },
  {
    path: '/asset-request/create',
    redirect: '/asset-requests/create'
  },
  {
    path: '/asset-request/:mode/:id?',
    redirect: (to) => {
      const { mode, id } = to.params;
      return id ? `/asset-requests/${mode}/${id}` : `/asset-requests/${mode}`;
    }
  },
  {
    path: '/asset-requests',
    name: 'asset-requests-list',
    meta: {
      title: 'Asset Request List',
      authRequired: true
    },
    component: () => import('../views/asset-request/index.vue')
  },
  {
    path: '/asset-requests/create',
    name: 'asset-requests-create',
    meta: {
      title: 'Create Asset Request',
      authRequired: true
    },
    component: () => import('../views/asset-request/asset-request-create.vue')
  },
  {
    path: '/asset-requests/:mode/:id?',
    name: 'asset-requests-upsert',
    meta: {
      title: 'Asset Request',
      authRequired: true
    },
    beforeEnter: (to, from, next) => {
      const mode = (to.params.mode || '').toString().toLowerCase();
      const id = to.params.id;
      const allowedModes = ['view', 'edit', 'add'];
      if (!mode || !allowedModes.includes(mode) || (mode !== 'add' && !id)) {
        next({ path: '/asset-requests', replace: true });
        return;
      }
      next();
    },
    component: () => import('../views/asset-request/asset-request-view-upsert.vue')
  },
  {
    path: '/analytics/user/:id?',
    name: 'analytics-user',
    meta: {
      title: 'User analytics',
      authRequired: true
    },
    component: () => import('../views/analytics/user-analytics.vue')
  },
  {
    path: '/analytics/project/:id?',
    name: 'analytics-project',
    meta: {
      title: 'Project analytics',
      authRequired: true
    },
    component: () => import('../views/analytics/project-analytics.vue')
  },
  {
    path: '/analytics/task/:id?',
    name: 'analytics-task',
    meta: {
      title: 'Task analytics',
      authRequired: true
    },
    component: () => import('../views/analytics/task-analytics.vue')
  },
  {
    path: '/analytics/department',
    name: 'analytics-department',
    meta: {
      title: 'department analytics',
      authRequired: true
    },
    component: () => import('../views/analytics/department-analytics.vue')
  },
  {
    path: '/evaluation/probation',
    name: 'probation-evaluation-list',
    meta: {
      title: 'Probation Evaluation List',
      authRequired: true,
      requiresPermission: 'probation-evaluation-list'
    },
    component: () => import('../views/probation-evaluation/list')
  },
  // Legacy URL — keep for backwards compatibility
  { path: '/probation-evaluation/list', redirect: '/evaluation/probation' },
  {
    path: '/probation-evaluation/:mode/:id?',
    name: 'probation-view-upsert',
    meta: {
      title: 'Create Probation Evaluation',
      authRequired: true
    },
    component: () => import('../views/probation-evaluation/probation-evaluation-view-upsert.vue')
  },
  {
    path: '/evaluation/performance',
    name: 'performance-evaluation-list',
    meta: {
      title: 'Performance Evaluation List',
      authRequired: true,
      requiresPermission: 'performance-evaluation-list'
    },
    component: () => import('../views/performance-evaluation/list')
  },
  // Legacy URL — keep for backwards compatibility
  { path: '/performance-evaluation/list', redirect: '/evaluation/performance' },
  {
    path: '/performance-evaluation/:mode/:id?',
    name: 'performance-view-upsert',
    meta: {
      title: 'Create Performance Evaluation',
      authRequired: true
    },
    component: () => import('../views/performance-evaluation/performance-evaluation-view-upsert.vue')
  },
  {
    path: '/candidates/list',
    name: 'candidates-list',
    meta: {
      title: 'Candidates List',
      authRequired: true
    },
    component: () => import('../views/candidates/list')
  },
  {
    path: '/candidates/:mode/:id?',
    name: 'candidates-view-upsert',
    meta: {
      title: 'Candidate',
      authRequired: true
    },
    component: () => import('../views/candidates/candidates-view-upsert.vue')
  },

  {
    path: '/approvalforms',
    name: 'forms-list',
    meta: {
      title: 'Forms List',
      authRequired: true
    },
    component: () => import('../views/form-approvals/list')
  },
  {
    path: '/forms/:mode/:id?',
    name: 'forms-view-upsert',
    meta: {
      title: 'Create Form',
      authRequired: true
    },
    component: () => import('../views/form-approvals/forms-view-upsert')
  },

  {
    path: '/leaves/list',
    name: 'leaves-list',
    meta: {
      title: 'Leaves',
      authRequired: true
    },
    component: () => import('../views/leaves/list')
  },
  {
    path: '/leaves/leaverequest',
    name: 'leaves-leaverequest-add',
    meta: {
      title: 'Leave Request',
      authRequired: true
    },
    component: () => import('../views/leaves/leaves-view-upsert')
  },
  {
    path: '/leaves/leaverequest/:mode/:id?',
    name: 'leaves-view-upsert',
    meta: {
      title: 'Leave Request',
      authRequired: true
    },
    component: () => import('../views/leaves/leaves-view-upsert')
  },
  {
    // Backwards-compat: /leaves/Add -> /leaves/leaverequest/Add (etc.)
    path: '/leaves/:mode(Add|Edit|View)/:id?',
    redirect: (to) => {
      const { mode, id } = to.params;
      return id ? `/leaves/leaverequest/${mode}/${id}` : `/leaves/leaverequest/${mode}`;
    }
  },
  {
    path: '/subscriptions',
    name: 'subscription',
    meta: {
      title: 'Subscription',
      authRequired: true
    },
    component: () => import('../views/subscriptions/list.vue')
  },
  {
    path: '/subscriptions/success-payment',
    name: 'subscription-success-payment',
    meta: {
      title: 'Subscription success payment',
      authRequired: true,
      layout: 'Blank'
    },
    component: () => import('../views/subscriptions/successSubscriptionPage.vue')
  },
  {
    path: '/subscriptions/failed-payment',
    name: 'subscription-failed-payment',
    meta: {
      title: 'Subscription failed payment',
      authRequired: true,
      layout: 'Blank'
    },
    component: () => import('../views/subscriptions/failedSubscriptionPage.vue')
  },

  {
    path: '/leaves/createleavetype',
    name: 'leaves-createleavetype-add',
    meta: {
      title: 'Leave Type',
      authRequired: true
    },
    component: () => import('../views/leaves/leaves-type-view-upsert')
  },
  {
    path: '/leaves/createleavetype/:mode/:id?',
    name: 'leaves-type-view-upsert-new',
    meta: {
      title: 'Leave Type',
      authRequired: true
    },
    component: () => import('../views/leaves/leaves-type-view-upsert')
  },
  {
    // Backwards-compat: /leaves-type/Add -> /leaves/createleavetype, /leaves-type/View/12 -> /leaves/createleavetype/View/12
    path: '/leaves-type/:mode/:id?',
    redirect: (to) => {
      const { mode, id } = to.params;
      if (!mode || mode === 'Add') return '/leaves/createleavetype';
      return id ? `/leaves/createleavetype/${mode}/${id}` : `/leaves/createleavetype/${mode}`;
    }
  },

  {
    path: '/news-section',
    name: 'news-sections',
    meta: {
      title: 'News Section',
      authRequired: true,
      layout: 'Blank'
    },
    component: () => import('../views/news-sections/index.vue')
  },

  {
    path: '/pages/maintenance',
    name: 'maintenance',
    meta: {
      layout: 'Blank',
      title: 'Maintanance',
      authRequired: false
    },
    component: () => import('../views/pages/maintenance')
  },

  {
    path: '/reset-password',
    name: 'reset-password',
    meta: {
      layout: 'Blank',
      title: 'Reset Password'
      // authRequired: true,
    },
    component: () => import('../views/account/reset-password'),
    beforeEnter: (to, from, next) => {
      // Assuming your logic to check if the email and token are valid
      if (to.query.token && to.query.email) {
        // You might want to validate the token here or in the component
        next();
      } else {
        next({
          name: 'Forgot password'
        }); // Redirect to forgot password page
      }
    }
  },

  {
    path: '/auth/400',
    name: '400',
    meta: {
      title: 'Error 400',
      layout: 'Blank',
      authRequired: false
    },
    component: () => import('../views/auth/errors/400.vue')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      layout: 'Blank',
      title: 'Error 500',
      authRequired: false
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      layout: 'Blank',
      title: 'Error 404',
      authRequired: false
    },
    component: () => import('../views/auth/errors/404-cover.vue')
  },
  {
    path: '/auth/inactive',
    name: 'Inactive',
    meta: {
      layout: 'Blank',
      title: 'Inactive',
      authRequired: false
    },
    component: () => import('../views/auth/errors/accessDenied.vue')
  },
  {
    path: '/auth/expirePlan',
    name: 'expirePlan',
    meta: {
      layout: 'Blank',
      title: 'Expire Plan',
      authRequired: false
    },
    component: () => import('../views/auth/errors/expirePlan.vue')
  },
  // {
  //   path: '/auth/404-basic',
  //   name: '404-basic',
  //   meta: {
  //     title: 'Error 404',
  //     authRequired: true
  //   },
  //   component: () => import('../views/auth/errors/404-basic')
  // },
  // {
  //   path: '/auth/404-cover',
  //   name: '404-cover',
  //   meta: {
  //     title: 'Error 404',
  //     authRequired: true
  //   },
  //   component: () => import('../views/auth/errors/404-cover')
  // },

  {
    path: '/time-tracking',
    name: 'time-tracking',
    meta: {
      title: 'time-tracking',
      authRequired: true
    },
    component: () => import('../views/time-tracking/index')
  },

  {
    path: '/organization-chart',
    name: 'organization-chart',
    meta: {
      title: 'Organization Chart',
      authRequired: true
    },
    component: () => import('../views/organization-chart/index')
  },
  {
    path: '/policy',
    name: 'policy',
    meta: {
      title: 'Policy',
      authRequired: true,
      requiresPermission: 'policy-content-tab-list'
    },
    component: () => import('../views/policy/index')
  },
  {
    path: '/car-reservation',
    name: 'car-reservation',
    meta: {
      title: 'Car Reservation',
      authRequired: true
    },
    component: () => import('../views/car-reservation/index')
  },
  {
    path: '/settings',
    name: 'settings',
    meta: {
      title: 'Settings',
      authRequired: true,
      requiresPermission: 'booking-setting-view'
    },
    component: () => import('../views/car-reservation/sitting')
  },
  {
    path: '/assets',
    name: 'Assets',
    meta: {
      title: 'Assets',
      authRequired: true
    },
    component: () => import('../views/Assets/index')
  },
  {
    path: '/Assets/Add',
    name: 'asset-add',
    meta: {
      title: 'Assets',
      authRequired: true
    },
    component: () => import('../views/Assets/asset-add')
  },
  {
    path: '/Assets/:mode/:id?',
    name: 'asset-manage',
    meta: {
      title: 'Assets',
      authRequired: true
    },
    component: () => import('../views/Assets/asset-view-upsert')
  },
  {
    path: '/driver-reservation',
    name: 'driver-reservation',
    meta: {
      title: 'Driver Reservation',
      authRequired: true
    },
    component: () => import('../views/driver-reservation/list.vue')
  },

  {
    path: '/driver/:mode/:id?',
    name: 'driver-view-upsert',
    meta: {
      title: 'Create Driver',
      authRequired: true
    },
    component: () => import('../views/driver-reservation/driver-view-upsert')
  },
  {
    path: '/room',
    name: 'room',
    meta: {
      title: 'Room',
      authRequired: true,
      requiresPermission: 'room-list'
    },
    component: () => import('../views/rooms/room.vue')
  },
  {
    path: '/room/building',
    name: 'building',
    meta: {
      title: 'Building',
      authRequired: true
    },
    component: () => import('../views/building/index')
  },
  {
    path: '/room-reservation',
    name: 'RoomReservation',
    meta: {
      title: 'Room Reservation',
      authRequired: true
    },
    component: () => import('../views/room-reservation/index')
  },
  {
    path: '/room/floor',
    name: 'floor',
    meta: {
      title: 'Floor',
      authRequired: true
    },
    component: () => import('../views/floor/index.vue')
  },
  {
    path: '/groups',
    name: 'groups',
    meta: {
      title: 'Groups',
      authRequired: true
    },
    component: () => import('../views/groups/index')
  },
  {
    path: '/cars',
    name: 'cars',
    meta: {
      title: 'Cars',
      authRequired: true,
      requiresPermission: 'car-list'
    },
    component: () => import('../views/cars/index')
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/auth/errors/400.vue'),
    props: true,
    meta: {
      layout: 'Blank'
    }
  }
];
